import { BRANCH_TYPE, TENANT_ID } from 'global/constants';

import { isInstallerRegisteringForBranch, isRegisteringBranchGuest } from 'utils/InstallerUtils';

import { NEFI_EI } from './EmailInput';
import { NEFI_FD } from './FormData';

const getFDExperts = (isEnergyActive, isGasActive, isEnergyGuest, isGasGuest) => {
  if (!isEnergyActive && !isGasActive) return [];

  if (isEnergyActive && isGasActive) {
    const key = `Energy${isEnergyGuest ? 'Guest' : 'Main'}Gas${isGasGuest ? 'Guest' : 'Main'}`;
    return NEFI_FD.experts[key];
  }

  if (isEnergyActive) {
    return NEFI_FD.experts[`Energy${isEnergyGuest ? 'Guest' : 'Main'}`];
  }

  return NEFI_FD.experts[`Gas${isGasGuest ? 'Guest' : 'Main'}`];
};

export const getFormDataConfigs = (tenantId, branchSelectionValues) => {
  const isEnergyActive = isInstallerRegisteringForBranch(BRANCH_TYPE.ENERGY, branchSelectionValues);
  const isGasActive = isInstallerRegisteringForBranch(BRANCH_TYPE.GAS, branchSelectionValues);
  const isEnergyGuest = isRegisteringBranchGuest(BRANCH_TYPE.ENERGY, branchSelectionValues);
  const isGasGuest = isRegisteringBranchGuest(BRANCH_TYPE.GAS, branchSelectionValues);
  const hasEntryGuest = isEnergyGuest || isGasGuest;

  const experts = getFDExperts(isEnergyActive, isGasActive, isEnergyGuest, isGasGuest);

  return {
    ...NEFI_FD.base.baseFormData,
    ...(tenantId === TENANT_ID.BAG ? NEFI_FD.base.BAGMainFields : {}),
    ...(tenantId === TENANT_ID.AVA && hasEntryGuest ? NEFI_FD.base.AVAGuestOnlyFields : {}),
    experts: experts(tenantId),
    ...NEFI_EI,
  };
};
